export enum WeatherAction {
  GET_WEATHER_TODAY = 'GET_WEATHER_TODAY',
  GET_WEATHER_WEEK = 'GET_WEATHER_WEEK'
}
